module.exports = __webpack_public_path__ + "static/img/viral_05.291da99f.jpg";